module.exports = __webpack_public_path__ + "img/magento-version-switching_medium@2x.0f75d4e1.jpg";